import Swiper from 'swiper/js/swiper';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

export default () => {

  // shop-menu-trigger fixed on mobile
  if (window.innerWidth < 1100) {
    ScrollTrigger.create({
        trigger: '.courses-header',
        start: '-100px top',
        endTrigger: '.info-claim',
        end: 'bottom 50px',
        // markers: true,
        pin: '.shop-menu-trigger',
        scrub: 1,
        // onEnter: self => $(self.trigger).addClass('shop-menu-trigger--active'),
        // onLeave: self => $(self.trigger).addClass('shop-menu-trigger--inactive'),
      });
  }

  // Product sliders
    var product_slider_instances = {},
      $product_slider_containers = $('.product-slider-container');

  if ($product_slider_containers.length > 0) {
    let spaceBetween = 15,
      slidesOffsetAfter = 15;
    // if (window.innerWidth > 576) { //$screen-sm-min
    //   spaceBetween = 50;
    //   slidesOffsetAfter = 50;
    // }

    $product_slider_containers.each(function(index){
      var $this = $(this);
      $this.addClass('product-slider-instance-' + index);
      $this.siblings('.product-slider-button-prev').eq(0).addClass('product-slider-button-prev-' + index);
      $this.siblings('.product-slider-button-next').eq(0).addClass('product-slider-button-next-' + index);
      var loop = !!$this.data('loop'); // Convert integer to boolean
      product_slider_instances[index] = new Swiper('.product-slider-instance-' + index, {
        slidesPerView: 'auto',
        loop: loop,
        spaceBetween: spaceBetween,
        effect: 'slide',
        slidesOffsetAfter: slidesOffsetAfter,
        freeMode: true,
        freeModeSticky: true,
        navigation: {
          nextEl: '.product-slider-button-next-' + index,
          prevEl: '.product-slider-button-prev-' + index,
        },
      });
    });
  }
};
